import { SettingsAPI } from '../../../api/spidermap/SettingsAPI';

export class SettingsCommand {
    listStops(successCallback, errorCallback) {
        const apiResult = SettingsAPI.listStops();
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as paragens");
            }
        });
    }

    getStopImageLink(stopCode, successCallback, errorCallback) {
        const apiResult = SettingsAPI.getStopImageLink(stopCode);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um carregar a imagem da paragem");
            }
        });
    }
}
